import { createNames } from "@ace/web-components/dist_lib/utils";
export const getAceBettingIconNames = (id) => {
    return createNames(id, 'ACE-BETTING-ICON');
};
//# sourceMappingURL=ace-betting-icon.get-names.js.map
